module.exports = __webpack_public_path__ + "static/media/nasa.8b14195c.png";